import { toggleMenu } from "./header";
import { scrollToHash, getSamePageAnchor } from "./smooth-scrolling";
import '../css/main.css';


document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */
  toggleMenu()

  /**
   * Example carousel import
   */
  const carousel = document.querySelectorAll(".carousel");
  if (carousel.length > 0) {
    import("./carousel").then((module) => {
      carousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  const carouselReviews = document.querySelectorAll(".carousel-reviews");
  if (carouselReviews.length > 0) {
    import("./carousel").then((module) => {
      carouselReviews.forEach((slider) => {
        module.carouselReviews(slider);
      });
    });
  }

  const carouselLogos = document.querySelectorAll(".carousel-logos");
  if (carouselLogos.length > 0) {
    import("./carousel").then((module) => {
      carouselLogos.forEach((slider) => {
        module.carouselLogos(slider);
      });
    });
  }

  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  document.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', e => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  });
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * ACF7 event listener
   */
  document.addEventListener('wpcf7mailsent', (event) => {
    gtag('event', 'Formulario', {
      'event_category': event.detail.contactFormId,
      'event_label': event.detail.unitTag
    });
  }, false);

  document.addEventListener('click', (event) => {
    const ctaButton = event.target.closest('.js-ads-cta, .cta a.bg-cinnamon, [class*="cta"] a.bg-cinnamon');
    if (!ctaButton) {
      return;
    }

    if (typeof gtag === 'function') {
      gtag('event', 'conversion', {
        'send_to': 'AW-18071639602',
        'event_category': 'cta',
        'event_label': ctaButton.textContent ? ctaButton.textContent.trim() : 'cta-button'
      });
    }
  });

  const videoContainers = document.querySelectorAll('[data-autoplay-video]');
  if (videoContainers.length > 0) {
    const updateVideoToggle = (toggle, isPaused) => {
      const playIcon = toggle.querySelector('[data-video-icon-play]');
      const pauseIcon = toggle.querySelector('[data-video-icon-pause]');

      playIcon.classList.toggle('hidden', !isPaused);
      pauseIcon.classList.toggle('hidden', isPaused);
      toggle.setAttribute('aria-label', isPaused ? 'Reproducir video' : 'Pausar video');
    };

    videoContainers.forEach(container => {
      const video = container.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', 'true');

        const toggle = container.querySelector('[data-video-toggle]');
        if (!toggle) {
          return;
        }

        const updateToggle = () => updateVideoToggle(toggle, video.paused);

        toggle.addEventListener('click', () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateToggle);
        video.addEventListener('pause', updateToggle);
        updateToggle();
      }
    });

    const youtubeFrames = Array.from(document.querySelectorAll('[data-youtube-video]'));
    if (youtubeFrames.length > 0) {
      const getYouTubeVideoId = (url) => {
        try {
          const parsedUrl = new URL(url);
          const hostname = parsedUrl.hostname.replace(/^(www\.|m\.)/, '');

          if (hostname === 'youtu.be') {
            return parsedUrl.pathname.split('/').filter(Boolean)[0] || null;
          }

          if (hostname === 'youtube.com' || hostname === 'youtube-nocookie.com') {
            const queryId = parsedUrl.searchParams.get('v');
            if (queryId) {
              return queryId;
            }

            const pathParts = parsedUrl.pathname.split('/').filter(Boolean);
            if (['embed', 'shorts', 'live'].includes(pathParts[0])) {
              return pathParts[1] || null;
            }
          }
        } catch (error) {
          return null;
        }

        return null;
      };

      const players = youtubeFrames.reduce((validFrames, frame) => {
        const videoId = getYouTubeVideoId(frame.dataset.youtubeUrl);
        if (!videoId) {
          return validFrames;
        }

        const params = new URLSearchParams({
          autoplay: '1',
          mute: '1',
          controls: '0',
          disablekb: '1',
          enablejsapi: '1',
          fs: '0',
          iv_load_policy: '3',
          loop: '1',
          playlist: videoId,
          playsinline: '1',
          rel: '0',
          origin: window.location.origin,
        });

        frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params}`;
        validFrames.push(frame);
        return validFrames;
      }, []);

      const resizePlayer = (frame) => {
        const container = frame.closest('[data-autoplay-video]');
        const containerRatio = container.clientWidth / container.clientHeight;
        const videoRatio = 16 / 9;

        if (containerRatio > videoRatio) {
          frame.style.width = `${container.clientWidth}px`;
          frame.style.height = `${container.clientWidth / videoRatio}px`;
        } else {
          frame.style.width = `${container.clientHeight * videoRatio}px`;
          frame.style.height = `${container.clientHeight}px`;
        }
      };

      players.forEach(frame => {
        resizePlayer(frame);
        new ResizeObserver(() => resizePlayer(frame)).observe(frame.closest('[data-autoplay-video]'));
      });

      if (players.length > 0) {
        const loadYouTubeApi = () => new Promise(resolve => {
          if (window.YT && window.YT.Player) {
            resolve(window.YT);
            return;
          }

          const previousCallback = window.onYouTubeIframeAPIReady;
          window.onYouTubeIframeAPIReady = () => {
            if (typeof previousCallback === 'function') {
              previousCallback();
            }
            resolve(window.YT);
          };

          if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
          }
        });

        loadYouTubeApi().then(YT => {
          players.forEach(frame => {
            const container = frame.closest('[data-autoplay-video]');
            const toggle = container.querySelector('[data-video-toggle]');
            let player;

            player = new YT.Player(frame, {
              events: {
                onReady: event => {
                  event.target.mute();
                  event.target.playVideo();
                  updateVideoToggle(toggle, false);
                },
                onStateChange: event => {
                  if (event.data === YT.PlayerState.PLAYING) {
                    updateVideoToggle(toggle, false);
                  } else if (event.data === YT.PlayerState.PAUSED) {
                    updateVideoToggle(toggle, true);
                  }
                },
              },
            });

            toggle.addEventListener('click', () => {
              if (player.getPlayerState() === YT.PlayerState.PLAYING) {
                player.pauseVideo();
              } else {
                player.playVideo();
              }
            });
          });
        });
      }
    }
  }
});
